import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IAppointment } from '../../../models/appointment.interface';
import { environment } from '../../../../environments/environment';
import { ConfirmationDialogService } from '../../../shared/confirmation-dialog/services/confirmation-dialog.service';
import { lastValueFrom } from 'rxjs';
import { AppointmentService } from '../../../services/appointment/appointment.service';

@Component({
    standalone: false,
    selector: 'cva-transcription-modal',
    templateUrl: './transcription-modal.component.html',
    styleUrl: './transcription-modal.component.scss',
    
})
export class TranscriptionModalComponent {
  cvaUI_url = environment.cvaUI_url;
  constructor(
    public dialogRef: MatDialogRef<TranscriptionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IAppointment,
    private readonly confirmationDialogService: ConfirmationDialogService,
    private readonly  appointmentService: AppointmentService
  ) { }

  deleteTranscription() {
    const confirmed$ = this.confirmationDialogService.openConfirmDialog("Do you want to delete the transcription?");
    lastValueFrom(confirmed$).then((isConfirmed: boolean) => {
      if(isConfirmed) {
        this.appointmentService.deleteTranscription(this.data.referenceId).subscribe(() => {
          this.dialogRef.close(true);
        });
      }
    });
  }
}
